import React from 'react';
import { useState, useEffect } from 'react';
import "../input/customInput.css"

const CustomInputValue = (props) => {
    let isRequied;
    let sizeClass;
    let typeInput = ""
    let checkValidation = true
    if(props.validation == undefined){

    }else if(props.validation == false){
        checkValidation = false
    }
    function enterValue(event){
        if(props.onChangeInput != undefined){
        props.onChangeInput(event.target.value)}
    }
   
   
    if(props.size == undefined){
        sizeClass = "bigInput";
    }else if(props.size == "small"){
        sizeClass = "smallInput";
    }else{
        sizeClass = "bigInput";
    }
    if(props.type == undefined){
        typeInput = "text"
    }else{
        typeInput =props.type;
    }
  

   
    

   


 //onClick={props.showCalendary!=undefined?(event)=>{props.showCalendary(event)}:""}
    return <>
    <div className='div_withTittle'>
    <div className='tittle'>
    <p className='tittle_forInput'>{props.title}</p>
    <p className={isRequied?'requied_forInput':'dontDisplay'}>{" *"}</p>
    </div>
    <div  className={checkValidation?'inputWithIcon ' + sizeClass :'inputWithIcon_invalid ' + sizeClass}>
    <input onChange={(event)=>{
        enterValue(event)}} onBlur={enterValue} id={props.id!=undefined?props.id:""} value={props.value} min={props.min!=undefined?props.min:""} max={props.max!=undefined?props.max:""} type={typeInput} className={'input_withTittle' }> 
    
    </input> 
    {props.icon}
    </div>
    </div>
    </>;
    };

export default CustomInputValue;
